module.exports = __webpack_public_path__ + "img/success.a7ef20a5.svg";